module.exports = __webpack_public_path__ + "img/128.3027bf04.jpg";